/** Bandeau des 4 chiffres. */
import { KpiCard } from "./KpiCard";
import type { DashKpi } from "./types";

type KpiRowProps = {
  items: DashKpi[];
  onOpen?: (kpi: DashKpi) => void;
};

export function KpiRow({ items, onOpen }: KpiRowProps) {
  return (
    <section className="fx-dash-4" aria-label="Vue d’ensemble">
      {items.map((kpi) => (
        <KpiCard key={kpi.id} kpi={kpi} onOpen={onOpen} />
      ))}
    </section>
  );
}
